interface UseResetHandlersProps {
  originValidation: {
    handleEditOrigin: () => void
    setLocalOriginPosition: (value: string) => void
  }
  quantityValidation: {
    handleEditQuantity: () => void
    setLocalQuantity: (value: string) => void
    setQuantityValidated: (value: boolean) => void
    setError: (value: string) => void
  }
  damageAssessment: {
    setShowMermaQuestion: (value: boolean) => void
    setIsAutoAssignedPosition: (value: boolean) => void
  }
  destinyValidation: {
    setLocalDestinyPosition: (value: string) => void
    setDestinyValidated: (value: boolean) => void
    setError: (value: string) => void
  }
  setSharedState: (updater: (prev: any) => any) => void
}

interface UseResetHandlersReturn {
  handleEditOriginWithReset: () => void
  handleEditQuantityWithReset: () => void
}

export const useResetHandlers = ({
  originValidation,
  quantityValidation,
  damageAssessment,
  destinyValidation,
  setSharedState
}: UseResetHandlersProps): UseResetHandlersReturn => {
  const handleEditOriginWithReset = () => {
    // Reset origin validation
    originValidation.handleEditOrigin()
    originValidation.setLocalOriginPosition('')

    // Reset quantity validation
    quantityValidation.setLocalQuantity('')
    quantityValidation.setQuantityValidated(false)
    quantityValidation.setError('')

    // Reset damage assessment
    damageAssessment.setShowMermaQuestion(false)
    damageAssessment.setIsAutoAssignedPosition(false)

    // Reset destiny validation
    destinyValidation.setLocalDestinyPosition('')
    destinyValidation.setDestinyValidated(false)
    destinyValidation.setError('')

    // Reset shared state additional fields
    setSharedState((prev) => ({
      ...prev,
      selectedBatch: undefined,
      availableBatches: [],
      showBatchModal: false,
      documentNumber: '',
      observations: '',
      requiresComments: false,
      destinyPositionType: undefined
    }))
  }

  const handleEditQuantityWithReset = () => {
    quantityValidation.handleEditQuantity()
    destinyValidation.setLocalDestinyPosition('')
    destinyValidation.setDestinyValidated(false)
    destinyValidation.setError('')
  }

  return {
    handleEditOriginWithReset,
    handleEditQuantityWithReset
  }
}
